// Hides the element found via the selector in data-target
$(document).on('click', '.js-dismiss', function(e) {
  e.preventDefault();
  $($(this).data('target')).hide();
});
